export var MuiMenu = {
    defaultProps: {
        elevation: 6,
    },
};
